import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { AirportService } from '../airport.service';
var NotamDetailsComponent = /** @class */ (function () {
    function NotamDetailsComponent(_matDialogRef, data, _airportService) {
        this._matDialogRef = _matDialogRef;
        this._airportService = _airportService;
        this.isLoading = true;
        this.airportFAAIdent = data.FaaId;
        this.country = data.country;
    }
    NotamDetailsComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        _a = this;
                        return [4 /*yield*/, this._airportService.getAirportNOTAMs(this.airportFAAIdent)];
                    case 1:
                        _a.notams = _b.sent();
                        this.notams = this.notams.filter(function (n) { return !n.isTfr; });
                        if (this.country === 'US') {
                            this.notams = this.notams.filter(function (n) { return !n.notamId.startsWith('A'); });
                        }
                        this._matDialogRef.backdropClick().subscribe(function () {
                            _this.close({ cancelBtnClicked: true });
                        });
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    NotamDetailsComponent.prototype.close = function (data) {
        this._matDialogRef.close(data);
    };
    NotamDetailsComponent.prototype.cancel = function () {
        this.close({ cancelBtnClicked: true });
    };
    return NotamDetailsComponent;
}());
export { NotamDetailsComponent };
